import CircularProgress from "@material-ui/core/CircularProgress";
import React from "react";
import { isEmpty } from "../utils/Validator.js";

export default (props) => {
  const { loadMsg, style } = props;

  if (isEmpty(loadMsg)) {
    return null;
  }

  return (
    <div
      className="App-loading-div"
      style={style}
      hidden={loadMsg === "" || loadMsg === null}
    >
      <CircularProgress color="primary" size="1.25em" />
      <span>{loadMsg}</span>
    </div>
  );
};
